<template>
	<modal :show.sync=show modalClasses="large-sized-modal" :hide-footer="true">
		<h3 slot="header" class="mb-0 font-weight-500">Detail Commission</h3>
		<b-form role="form" @submit.prevent="editCommission" class="commission-setting">
			<b-row>
				<!-- FIELD ROLE NAME -->
				<b-col cols="12" class="mb-2">
					<h3 class="font-weight-600 mb-0">Commission Setting Name :</h3>
					<p>{{data_form.cset_label}}</p>
				</b-col>
				<!-- FIELD ROLE Group Type -->
				<b-col cols="12" class="mb-2">
					<h3 class="font-weight-600 mb-0">Commission Code :</h3>
					<p>{{data_form.cset_code}}</p>
				</b-col>
				<!-- FIELD ROLE DESCRIPTION -->
				<b-col cols="12" class="mb-2">
					<h3 class="font-weight-600">Setting Details :</h3>
					<template v-if="isArray(data_form.cset_value)">
						<div class="table-simple-modal">
							<b-table-simple responsive bordered>
								<b-thead>
									<b-tr>
										<b-th v-for="(data_value, data_key) in data_form.cset_value[0]" :key="data_key">{{ data_key | removeUnderscore }}</b-th>
									</b-tr>
								</b-thead>
								<b-tbody>
									<b-tr v-for="(data, key) in data_form.cset_value" :key="key">
										<b-td v-for="(data_value, data_key) in data" :key="data_key">
											<template v-if="!isArray(data_value)">
												<template v-if="is_show_detail">
													{{ data_value }}
												</template>
												<template v-else>
													<b-form-input
													v-model="data_form.cset_value[key][data_key]"
													type="text"
													:disabled="is_show_detail"
													></b-form-input>
												</template>
											</template>
											<template v-else>
												<template v-if="is_show_detail">
													<b-row v-for="(data_value_data, data_value_key) in data_value" :key="data_value_key">
														<b-col class="custom-width" v-for="(inner_data, inner_key) in data_value_data" :key="inner_key">
															{{ inner_key | removeUnderscore}} :
															{{ data_form.cset_value[key][data_key][data_value_key][inner_key] }}
														</b-col>
													</b-row>
												</template>
												<template v-else>
													<b-row v-for="(data_value_data, data_value_key) in data_value" :key="data_value_key">
														<b-col class="custom-width" v-for="(inner_data, inner_key) in data_value_data" :key="inner_key">
															{{ inner_key | removeUnderscore}} :
															<b-form-input
															v-model="data_form.cset_value[key][data_key][data_value_key][inner_key]"
															type="text"
															:disabled="is_show_detail"
															></b-form-input>
														</b-col>
													</b-row>
														<!-- <b-col v-for="(inner_data, inner_key) in data_value" :key="inner_key">
															{{ inner_data }}
														</b-col> -->
													
												</template>
											</template>
											
										</b-td>
									</b-tr>
								</b-tbody>
							</b-table-simple>
						</div>
					</template>
					<template v-else>
						<div class="table-simple-modal">
							<b-table-simple responsive bordered>
								<b-thead>
									<b-tr>
										<b-th v-for="(data_value, data_key) in data_form.cset_value" :key="data_key">
											{{ data_key | removeUnderscore }}
										</b-th>
									</b-tr>
								</b-thead>
								<b-tbody>
									<b-tr>
										<b-td v-for="(data_value, data_key) in data_form.cset_value" :key="data_key">
											<template v-if="is_show_detail">{{ data_value }}</template>
											<template v-else>
												<b-form-input
												v-model="data_form.cset_value[data_key]"
												type="text"
												:disabled="is_show_detail"
												></b-form-input>
											</template>
										</b-td> 
									</b-tr>
								</b-tbody>
							</b-table-simple>
						</div>
					</template>
				</b-col>
				<b-col v-if="is_show_detail == false" md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
					<b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_btn">Save</b-button>
				</b-col>
			</b-row>
		</b-form>
	</modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, CheckboxGroup, Checkbox } from 'element-ui'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import mainEventBus from '@/assets/js/mainEventBus.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import _ from 'lodash'

export default {
	props: {
		detail_commission: Boolean,
		commission_item: {
			type: Object
		},
		is_show_detail: Boolean,
	},
	mixins: [
		notifyFunctionMixin,
		helperFunctionMixin
	],
	components: {
		Modal,
		ValidationObserver,
		ValidationProvider,
		[Select.name]: Select,
		[Option.name]: Option,
		[CheckboxGroup.name]: CheckboxGroup,
		[Checkbox.name]: Checkbox,
	},
	computed: {
		show: {
			get() {
				return this.detail_commission;
			},
			set(newVal) {
				this.$emit('update:detail_commission', newVal);
			},
        },
        isObject() {
          return typeof this.data_form.cset_value === 'object' && !Array.isArray(this.data_form.cset_value);
        },

	},
	data() {
		return {
			data_form: {
				cset_code: '',
				cset_label: '',
				cset_value: '',
			},
            fields: ['product', 'percentage', 'sales_amount'],
			form: [],
			is_loading_btn: false,
		}
	},
	async created() {
		this.$watch(
			() => this.commission_item,
			(newVal) => {
				if (newVal) {
					this.data_form.cset_code = newVal.cset_code ?? '';
					this.data_form.cset_label = newVal.cset_label ?? '';
					this.data_form.cset_value = newVal.cset_value ?? '';
                    if(typeof newVal.cset_value === 'object' && !Array.isArray(newVal.cset_value))
                    {
                        this.data_form.data_key = Object.keys(newVal.cset_value);
                    }
                    else
                    {
                        this.data_form.data_key = Object.keys(newVal.cset_value[0]);
                    }
				}
			},
		)
	},
	methods: {
        getTableFields() {
            const fields = [];
            const firstItem = this.data_form.cset_value[0];

            if (firstItem) {
                // Loop through keys in the first item
                for (const key in firstItem) {
                if (Object.prototype.hasOwnProperty.call(firstItem, key)) {
                    fields.push({ key, label: key });
                }
                }
            }

            return fields;
        },
		isArray(data) {
			return Array.isArray(data);
		},
		editCommission() {
			const postData = this.data_form
			axios.post(services.commission + '/commission-setting/' + this.data_form.cset_code, postData,{headers: getHeader()})
            .then(res => {
				console.log(res.data);
                this.notifySuccess('Commission Settings: ' + this.data_form.cset_label + ' successfully updated.')
            })
            .catch(e => {
                this.errorFunction(e)
            })
		}
	}
}
</script>